import { render, staticRenderFns } from "./common-introduce.vue?vue&type=template&id=2443314f&scoped=true&lang=html&"
import script from "./common-introduce.vue?vue&type=script&lang=js&"
export * from "./common-introduce.vue?vue&type=script&lang=js&"
import style0 from "./common-introduce.vue?vue&type=style&index=0&id=2443314f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2443314f",
  null
  
)

export default component.exports